import {
    DEFAULT_COUNT_DOWN_TIME_LIMIT,
    DEFAULT_POLL_BREAK_TIME_LIMIT,
    POLL_TYPE,
    USER_SETTINGS
} from "../../utils/constants";
import settingsClasses from "../PlatformSetting/Settings.module.css";
import React, {useState} from "react";
import {deCapitalizeWord} from "../../utils/helpers";
import {useTranslation} from "react-i18next";
import classes from "./ActivityEditor.module.css";
import TimeLimitInput from "../../components/TimeLimitInput";
import YuJaSwitch from "../../components/standardization/YuJaSwitch";

export default function ActivityEditorConfigurationSectionA({draftActivity, setDraftActivity, userSettings, hasReleased}) {
    const {t} = useTranslation();
    const columnLayoutStyle = {width: "100%", display: "flex", flexDirection: "column"};

    return (
        <div className={classes.settingsGridLayout}>
            {/*get ready time limit*/}
            {draftActivity.pollType !== POLL_TYPE.ATTENDANCE &&
                <>
                    <div style={columnLayoutStyle}>
                        <div className={settingsClasses.settingLabel}>{t("questionBuilder.countdownTimerLabel")}</div>
                        <div className={settingsClasses.settingDescription}>{t("questionBuilder.pollCountdownTimerDescription")}</div>
                    </div>

                    <TimeLimitInput
                        timeLimit={draftActivity.getReadyAllTimeLimit}
                        setTimeLimit={(timeLimit) => {
                            let copy = JSON.parse(JSON.stringify(draftActivity));
                            copy.getReadyAllTimeLimit = timeLimit;
                            setDraftActivity(copy);
                        }}
                        unit={"MM:SS"}
                        minVal={DEFAULT_COUNT_DOWN_TIME_LIMIT}
                        reachMinValErrorText={t("settings.minimumCountdownError")}
                    />
                </>
            }


            {/*Time Limit*/}
            {draftActivity.pollType === POLL_TYPE.ATTENDANCE &&
                <>
                    <div style={columnLayoutStyle}>
                        <div className={settingsClasses.settingLabel}>{t("gradebook.attendanceLengthSettingText")}</div>
                        <div className={settingsClasses.settingDescription}>{t("gradebook.attendanceLengthSettingDesc")}</div>
                    </div>
                    <YuJaSwitch
                        aria-label={t("gradebook.attendanceLengthSettingText")}
                        checked={draftActivity.manualEnd === "true" || draftActivity.manualEnd === true}
                        onChange={checked => {
                            const copy = JSON.parse(JSON.stringify(draftActivity));
                            copy.manualEnd = checked;

                            if (!checked && !draftActivity.attendanceDuration) {
                                copy.attendanceDuration = userSettings[USER_SETTINGS.ATTENDANCE_DURATION];
                            }

                            setDraftActivity(copy);
                        }}
                    />

                    {(draftActivity.manualEnd === "false" || draftActivity.manualEnd === false) &&
                        <>
                            <div style={columnLayoutStyle}>
                                <span className={settingsClasses.settingLabel}>{t("questionBuilder.pollTimeLimitText")}</span>
                                <span className={settingsClasses.settingDescription}>
                                    {t("poll.participantTimeIntro", {
                                        activityType: draftActivity.pollType === POLL_TYPE.ATTENDANCE
                                            ? deCapitalizeWord(t("attendance.label"))
                                            : deCapitalizeWord(t("poll.mergedModeText"))
                                    })}
                                </span>
                            </div>

                            <TimeLimitInput
                                timeLimit={draftActivity.attendanceDuration}
                                setTimeLimit={(timeLimit) => {
                                    const copy = JSON.parse(JSON.stringify(draftActivity));
                                    copy.attendanceDuration = timeLimit;
                                    if (!timeLimit) {
                                        copy.manualEnd = true;
                                    }
                                    setDraftActivity(copy);
                                }}
                                unit={"HH:MM"}
                            />
                        </>
                    }

                    {/*{(draftActivity.manualEnd === "false" || draftActivity.manualEnd === false) &&*/}
                    {/*    <div style={{...columnLayoutStyle, gridColumn: "1/-1", flexDirection: "row", gap: 5,}}>*/}
                    {/*        <span style={{marginTop: 6}}> {PARTICIPANT_TIME_INTRO}</span>*/}
                    {/*        <div style={{display: "flex", gap: "5px"}}>*/}
                    {/*            <div style={{display: "flex", flexDirection: "column"}}>*/}
                    {/*                <YuJaTextBox*/}
                    {/*                    containerStyle={{width: 50, height: 35}}*/}
                    {/*                    inputAlign={"center"}*/}
                    {/*                    value={attendanceTimeLimit.split(":")[0]}*/}
                    {/*                    onChange={handleAttendanceDurationChangeH}*/}
                    {/*                    onBlur={handleAttendanceDurationBlur}*/}
                    {/*                    placeholder={"00"}*/}
                    {/*                    type={"number"}*/}
                    {/*                />*/}
                    {/*                <div style={{fontSize: 13, fontWeight: "400", textAlign: "center"}}>{HOURS}</div>*/}
                    {/*            </div>*/}
                    {/*            <div style={{marginTop: 6}}> :</div>*/}
                    {/*            <div style={{display: "flex", flexDirection: "column"}}>*/}
                    {/*                <YuJaTextBox*/}
                    {/*                    containerStyle={{width: 50, height: 35}}*/}
                    {/*                    inputAlign={"center"}*/}
                    {/*                    value={attendanceTimeLimit.split(":")[1]}*/}
                    {/*                    onChange={handleAttendanceDurationChangeM}*/}
                    {/*                    onBlur={handleAttendanceDurationBlur}*/}
                    {/*                    placeholder={"00"}*/}
                    {/*                    type={"number"}*/}
                    {/*                />*/}
                    {/*                <div style={{fontSize: 13, fontWeight: "400", textAlign: "center"}}>{MINUTES}</div>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*        {ATTENDANCE_LENGTH_SETTING_DESCRIPTION.split(" ").map((word, index) =>*/}
                    {/*            <span key={index} style={{marginTop: 6}}> {word} </span>*/}
                    {/*        )}*/}

                    {/*    </div>*/}
                    {/*}*/}
                </>
            }

            {draftActivity.pollType !== POLL_TYPE.ATTENDANCE &&
                <>
                    <div style={columnLayoutStyle}>
                        <div className={settingsClasses.settingLabel}>{t("gradebook.pollLengthSettingText")}</div>
                        <div className={settingsClasses.settingDescription}>{t("gradebook.pollLengthSettingDesc")}</div>
                    </div>
                    <YuJaSwitch
                        aria-label={t("gradebook.pollLengthSettingText")}
                        checked={draftActivity.manualEnd === "true" || draftActivity.manualEnd === true}
                        onChange={checked => {
                            const copy = JSON.parse(JSON.stringify(draftActivity));
                            copy.manualEnd = checked;
                            if (!checked && !draftActivity.pollTimeLimit) {
                                copy.pollTimeLimit = userSettings[USER_SETTINGS.POLL_DURATION];
                            }
                            setDraftActivity(copy);
                        }}
                    />


                    {(draftActivity.manualEnd === "false" || draftActivity.manualEnd === false) &&
                        <>
                            <div style={columnLayoutStyle}>
                                <span className={settingsClasses.settingLabel}>{t("questionBuilder.pollTimeLimitText")}</span>
                                <span className={settingsClasses.settingDescription}>
                                    {t("poll.participantTimeIntro", {
                                        activityType: draftActivity.pollType === POLL_TYPE.ATTENDANCE
                                            ? deCapitalizeWord(t("attendance.label"))
                                            : deCapitalizeWord(t("poll.mergedModeText"))
                                    })}
                                </span>
                            </div>

                            <TimeLimitInput
                                timeLimit={draftActivity.pollTimeLimit}
                                setTimeLimit={(timeLimit) => {
                                    const copy = JSON.parse(JSON.stringify(draftActivity));
                                    copy.pollTimeLimit = timeLimit;
                                    if (!timeLimit) {
                                        copy.manualEnd = true;
                                    }
                                    setDraftActivity(copy);
                                }}
                                unit={"HH:MM"}
                            />
                        </>
                    }

                </>
            }

            {/*   Poll End Countdown */}
            {draftActivity.pollType !== POLL_TYPE.ATTENDANCE &&
                <>
                    <div style={columnLayoutStyle}>
                        <span className={settingsClasses.settingLabel}>{t("questionBuilder.pollBreakDurationLabel")}</span>
                        <span className={settingsClasses.settingDescription}>
                            {t("poll.pollEndFlexibleTimeDescription", {activityType: deCapitalizeWord(t("poll.mergedModeText"))})}
                        </span>
                    </div>

                    <TimeLimitInput
                        timeLimit={draftActivity.pollBreakDuration}
                        setTimeLimit={(timeLimit) => {
                            const copy = JSON.parse(JSON.stringify(draftActivity));
                            copy.pollBreakDuration = timeLimit;
                            setDraftActivity(copy);
                        }}
                        minVal={DEFAULT_POLL_BREAK_TIME_LIMIT}
                        reachMinValErrorText={t("settings.minimumBreakDurationError")}
                        unit={"MM:SS"}
                    />
                </>
            }

            {/*show correct answer*/}
            {draftActivity.pollType !== POLL_TYPE.ATTENDANCE &&
                <>
                    <div style={columnLayoutStyle}>
                        <div className={settingsClasses.settingLabel}>{t("questionBuilder.showCorrectAnswerTitle")}</div>
                        <div className={settingsClasses.settingDescription}>{t("questionBuilder.showCorrectAnswerDescription")}</div>
                    </div>

                    <YuJaSwitch
                        aria-label={t("questionBuilder.showCorrectAnswerTitle")}
                        checked={draftActivity.showAnswerOnViewer === "true" || draftActivity.showAnswerOnViewer === true}
                        onChange={checked => {
                            const copy = JSON.parse(JSON.stringify(draftActivity));
                            copy.showAnswerOnViewer = checked;
                            setDraftActivity(copy);
                        }}
                    />

                </>
            }



        </div>
    );
}